import {
  LinkedBankAccountStatuses,
  type LinkedBankAccountStatusEnum,
} from '../enums/LinkedBankAccountStatusEnum'

export interface LinkedBankAccountConstructor {
  id: number
  uuid: string
  bankName: string
  accountName: string
  accountMask: string
  status: LinkedBankAccountStatusEnum
  glCode: string
}

export class LinkedBankAccount {
  readonly id: number
  readonly uuid: string
  readonly bankName: string
  readonly accountName: string
  readonly accountMask: string
  readonly status: LinkedBankAccountStatusEnum
  readonly glCode: string

  constructor(data: LinkedBankAccountConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.bankName = data.bankName
    this.accountName = data.accountName
    this.accountMask = data.accountMask
    this.status = data.status
    this.glCode = data.glCode
  }

  get isPending(): boolean {
    return this.status === LinkedBankAccountStatuses.PENDING
  }

  get isVerified(): boolean {
    return this.status === LinkedBankAccountStatuses.VERIFIED
  }

  get isActionRequired(): boolean {
    return this.status === LinkedBankAccountStatuses.REQUIRE_ACTION
  }

  get isSuspended(): boolean {
    return this.status === LinkedBankAccountStatuses.SUSPENDED
  }

  get isVerificationFailed(): boolean {
    return this.status === LinkedBankAccountStatuses.VERIFICATION_FAILED
  }

  get isRemoved(): boolean {
    return this.status === LinkedBankAccountStatuses.REMOVED
  }
}
